var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28C18.4478 28 21.7544 26.6304 24.1924 24.1924C26.6304 21.7544 28 18.4478 28 15C28 11.5522 26.6304 8.24558 24.1924 5.80761C21.7544 3.36964 18.4478 2 15 2C11.5522 2 8.24558 3.36964 5.80761 5.80761C3.36964 8.24558 2 11.5522 2 15C2 18.4478 3.36964 21.7544 5.80761 24.1924C8.24558 26.6304 11.5522 28 15 28Z",
    fill: "url(#paint0_linear_44_11109)",
    stroke: "#EBB957",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7064 9.5697C12.5659 9.48185 12.4043 9.43323 12.2387 9.42888C12.073 9.42453 11.9091 9.46461 11.7641 9.54496C11.6192 9.62531 11.4983 9.74301 11.4142 9.88583C11.3301 10.0286 11.2857 10.1914 11.2857 10.3571V19.6428C11.2857 19.8086 11.3301 19.9713 11.4142 20.1142C11.4983 20.257 11.6192 20.3747 11.7641 20.455C11.9091 20.5354 12.073 20.5755 12.2387 20.5711C12.4043 20.5667 12.5659 20.5181 12.7064 20.4303L20.135 15.7874C20.2685 15.7039 20.3787 15.5879 20.455 15.4501C20.5314 15.3124 20.5714 15.1575 20.5714 15C20.5714 14.8425 20.5314 14.6876 20.455 14.5498C20.3787 14.4121 20.2685 14.296 20.135 14.2126L12.7064 9.5697Z",
    fill: "#CC962B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_11109",
    x1: 6.33333,
    y1: 6.33333,
    x2: 22.5833,
    y2: 26.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4DD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleFill);
export default __webpack_public_path__ + "static/media/play-circle-fill.bea8d1f3175b2184a5bd602be43f24b3.svg";
export { ForwardRef as ReactComponent };